import React from 'react';
// import {createBrowserInspector} from '@statelyai/inspect';
import {
  type IRootMachineInput,
  RootMachineContext,
} from './machines/rootMachine';
import {getBrowserTimezone} from './utils/date';
import {getQueryParams} from './utils/url';
import {RootLayout} from './components/root-layout/root-layout';
import useLabelTranslation from 'src/hooks/useLabelTranslation.ts';

// const {inspect} = createBrowserInspector({
//   autoStart: true,
// });

export function App({
  currentRoute,
  id,
  env,
  countyCode,
}: {
  currentRoute: string;
  id: string;
  env: string;
  countyCode: string;
}) {
  const timezone = getBrowserTimezone();
  const {aid, attendee, session_id} = getQueryParams<{
    aid?: string;
    attendee?: string;
    session_id?: string;
  }>();
  const {language} = useLabelTranslation();

  const initialInput: IRootMachineInput = {
    currentRoute,
    id,
    aid,
    attendee,
    timezone,
    language,
    sessionId: session_id,
    countyCode,
  };

  return (
    <RootMachineContext.Provider
      options={{
        input: initialInput,
        // inspect,
      }}
    >
      <RootLayout />
    </RootMachineContext.Provider>
  );
}
